import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Inbox.LIST_SUCCESS:
      if (Array.isArray(action.payload) && action.newConversationSelected) {
        const inboxByContactID = action.payload.reduce((acc, el) => {
          acc[el.contact_id] = true
          return acc
        }, {})

        if (inboxByContactID[action.newConversationSelected]) {
          return action.newConversationSelected
        }
      }
      return state
    case ActionType.Inbox.SELECT_NEW_CONVERSATION:
      return null
    case ActionType.Inbox.SELECT_CONVERSATION:
      return action.payload
    case ActionType.Inbox.SELECT_CONTACT:
      return null
    case '@@router/LOCATION_CHANGE':
      if (
        action.payload &&
        action.payload.location &&
        action.payload.location.pathname === '/inbox'
      ) {
        return state
      }
      return null
    default:
      return state
  }
}
